// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LCjn","toggle":"styles_toggle__2Ndpa","preview":"styles_preview__1tgKl"};